import React from 'react';

const SelectCompanyConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false,
                },
                toolbar: {
                    display: false,
                },
                footer: {
                    display: false,
                },
                leftSidePanel: {
                    display: false,
                },
                rightSidePanel: {
                    display: false,
                },
            },
        },
    },
    routes: [
        {
            path: '/select-company',
            component: React.lazy(() => import('./SelectCompany')),
        },
    ],
};

export default SelectCompanyConfig;
